import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './DatePickerCell.css';

const DatePickerCell = ({ date, onDateChange, formatDate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(date ? new Date(date) : null);
  const cellRef = useRef(null);
  const popoverRef = useRef(null);

  // Quick preset options
  const presets = [
    { label: 'Today', date: new Date() },
    { label: 'Tomorrow', date: new Date(Date.now() + 86400000) },
    { label: 'Next Week', date: new Date(Date.now() + 604800000) },
  ];

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target) &&
          cellRef.current && !cellRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  // Close on escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isOpen]);

  const handlePresetClick = (presetDate) => {
    setSelectedDate(presetDate);
    onDateChange(presetDate);
    setIsOpen(false);
  };

  const handleSetDate = () => {
    onDateChange(selectedDate);
    setIsOpen(false);
  };

  const handleClear = () => {
    setSelectedDate(null);
    onDateChange(null);
    setIsOpen(false);
  };

  return (
    <div className="date-picker-cell" ref={cellRef}>
      <button
        className="due-date-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Set due date"
        aria-expanded={isOpen}
      >
        {formatDate(date)}
      </button>

      {isOpen && (
        <div className="date-picker-popover" ref={popoverRef}>
          <div className="date-picker-header">
            <span>📅 Set Due Date</span>
          </div>
          
          <div className="date-picker-presets">
            {presets.map(preset => (
              <button 
                key={preset.label}
                className="preset-btn"
                onClick={() => handlePresetClick(preset.date)}
              >
                {preset.label}
              </button>
            ))}
          </div>

          <div className="date-picker-calendar">
            <DatePicker
              selected={selectedDate}
              onChange={setSelectedDate}
              inline
              calendarClassName="custom-calendar"
            />
          </div>

          <div className="date-picker-actions">
            <button 
              className="btn-secondary" 
              onClick={handleClear}
            >
              Clear
            </button>
            <button 
              className="btn-primary" 
              onClick={handleSetDate}
              disabled={!selectedDate}
            >
              Set Date
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DatePickerCell;